<template>
<LayoutContent class="env-history-layout-content">
  <template #toolbar>
    <data-time-query :query="query" />

    <el-select
      v-model="query.siteId"
      size="small"
      style="width:120px;"
      @change="onSiteChange"
    >
      <el-option
        v-for="site in filterSites"
        :key="site.id"
        :value="site.id"
        :label="site.name"
      />
    </el-select>

    <el-checkbox v-model="isShowGroup" size="small" label="显示分组" border v-if="displayType === 2 && envCategoryList.length > 0" />

    <display-type
      :default-display-type.sync="displayType"
    />

    <el-button
      type="orange"
      size="small"
      icon="el-icon-search"
      @click="onSearchBtnClick"
    >查询</el-button>
  </template>

  <template #body>
    <data-wrapper>
      <div class="select-group-wrapper">
        <z-tree
          ref="area-tree"
          v-model="areaId"
          :list="formatAreas"
          expand-all
          @change="onAreaIdChanged"
        >
          <template #header>
            <h3 style="font-size:16px;color:#303133;">选择区域</h3>
          </template>
        </z-tree>
      </div>

      <div>
        <Component
          v-if="!isShowGroup"
          :is="`display-type${displayType}`"
          :is-show-group="isShowGroup"
          :list="dataList"
          :column-map="columnMap"
          :pagination="pagination"
          :env-factor-map="envSiteIdFactorMap[query.siteId]"
        />
        <Component
          v-else
          :is="`display-type${displayType}`"
          :is-show-group="isShowGroup"
          :env-category-list="envCategoryList"
          :env-factor-map="envSiteIdFactorMap[query.siteId]"
          :list="dataList"
          :column-map="columnMap"
        />
      </div>
    </data-wrapper>
  </template>
</LayoutContent>
</template>

<script>
import BaseDateData from '../../BaseDateData'
import {mapGetters} from 'vuex'

import LayoutContent from '../../../components/Layout/Content'
import DataTimeQuery from '../../../components/Data/Query/DataTimeQuery'
import DisplayType from '../../../components/Data/DisplayType'
import DataWrapper from '../../../components/Data/DataWrapper'
import ZTree from '../../../components/ZTree'
import DisplayType1 from './Table'
import DisplayType2 from './Charts'
import ZTablePagination from '../../06Data-Management/02Normal/08VOCs-Data-Compare/ZTablePagination'

export default {
  name: 'SiteEnvHistory',
  routeInfo: {
    label: '历史数据',
    icon: 'fa fa-users'
  },
  extends: BaseDateData,
  components: {DisplayType, ZTree, LayoutContent, DataTimeQuery, DataWrapper, DisplayType1, DisplayType2},
  data: () => ({
    query: {
      siteId: null
    },
    areaId: null,
    dataList: Object.freeze([]),
    displayType: 2,
    isShowGroup: false,
    envCategoryList: [],
    columnMap: Object.freeze({}),
    pagination: new ZTablePagination(1, 100)
  }),
  computed: {
    ...mapGetters({
      envSiteIdFactorMap: 'EnvFactor/map',
      areaSiteIdMap: 'EnvFactor/areaMap'
    }),
    filterSites () {
      let {areaSiteIdMap} = this
      return this.profileSites.filter(site => areaSiteIdMap[site.id])
    },
    currentSite () {
      let {siteId} = this.query
      return this.filterSites.find(site => site.id === siteId)
    },
    areaMap () {
      let {siteId} = this.query

      if (!siteId) {
        return null
      }
      let siteFactors = Object.values(this.envSiteIdFactorMap[siteId]).filter(el => !el.isDelete && el.status).map(el => el.id)

      let areaMap = this.areaSiteIdMap[siteId]
      let newAreaMap = Object.values(areaMap).map(el => {
        let factorIds = []

        el.factorIds.forEach(item => {
          if (siteFactors.includes(item)) {
            factorIds.push(item)
          }
        })

        el.factorIds = factorIds
        return {...el}
      }).reduce((map, el) => {
        map[el.id] = el
        return map
      }, {})
      return areaMap ? JSON.parse(JSON.stringify(newAreaMap)) : null
    },
    formatAreas () {
      let {areaMap} = this
      if (!areaMap) {
        return []
      }
      let filterAreaMap = Object.values(areaMap).filter(el => !el.isDelete)

      let childrenMap = filterAreaMap.reduce((map, el) => {
        if (el.parentId) {
          if (!map[el.parentId]) {
            map[el.parentId] = []
          }

          map[el.parentId].push(el)
        }

        return map
      }, {})

      return filterAreaMap.reduce((list, area) => {
        let {factorIds} = area

        let num = factorIds.length
        if (childrenMap[area.id] && childrenMap[area.id].length > 0) {
          let temp = childrenMap[area.id].map(el => el.factorIds).flat()
          num += temp.length
        }

        list.push({
          id: area.id,
          name: `${area.name} ${num > 0 ? '(' + num + ')' : ''}`,
          parentId: area.parentId || '_ROOT',
          factorIds
        })

        return list
      }, [{
        id: '_ROOT',
        name: '所有区域 (' + filterAreaMap.map(el => el.factorIds).flat().length + ')',
        parentId: null,
        factorIds: []
      }])
    },
    newAreaMap () {
      return this.formatAreas.reduce((map, area) => {
        map[area.id] = area
        return map
      }, {})
    },
    currentArea () {
      return this.newAreaMap[this.areaId]
    },
    factorMap () {
      return this.envSiteIdFactorMap[this.query.siteId]
    },
    factors () {
      let {factorMap} = this
      return factorMap ? Object.values(factorMap) : []
    }
  },
  methods: {
    setAreaId () {
      // setTimeout(() => {
      //   if (!this.areaMap[this.areaId]) {
      //     let areaTree = [...this.$refs['area-tree'].tree]
      //
      //     for (let i = 0; i < areaTree.length; i++) {
      //       let area = areaTree[i]
      //
      //       if (area.factorIds.length > 0) {
      //         this.areaId = area.id
      //         break
      //       }
      //
      //       let {children} = area
      //
      //       if (children) {
      //         areaTree.push(...children)
      //       }
      //     }
      //   }
      // }, 0)
      this.areaId = '_ROOT'
    },
    setColumnMap () {
      let {treeMap} = this.$refs['area-tree']
      if (!treeMap) {
        this.columnMap = Object.freeze({})
        return
      }
      let currentArea = treeMap[this.areaId]

      if (!currentArea) {
        this.columnMap = Object.freeze({})
        return
      }

      let tmp = [currentArea]
      let factorIdMap = {}

      for (let i = 0; i < tmp.length; i++) {
        let area = tmp[i]
        let {factorIds} = area
        let {length} = factorIds

        for (let j = 0; j < length; j++) {
          factorIdMap[factorIds[j]] = true
        }

        let {children} = area

        if (children) {
          tmp.push(...children)
        }
      }

      this.columnMap = Object.freeze(this.factors.filter(factor => !factor.isDelete && factorIdMap[factor.id]).reduce((map, factor) => {
        map[factor.id] = factor
        return map
      }, {}))
    },
    setData (dataList) {
      this.setColumnMap()
      this.dataList = Object.freeze(dataList)
    },
    getData () {
      setTimeout(() => {
        this.$store.commit('LoadStatus/status', true)
        this.$api.EnvFactor.getHistoryData(this.query).then(this.setData).catch(console.error).finally(() => {
          this.$store.commit('LoadStatus/status', false)
        })
      }, 0)
    },
    onSearchBtnClick () {
      this.getData()
    },
    onSiteChange (siteId) {
      let {query} = this
      query.siteId = siteId
      this.getData()
      this.setAreaId()
    },
    onSiteClick (site) {
      let siteId = site.id
      let {query} = this

      if (siteId === query.siteId) {
        return
      }

      query.siteId = siteId
      this.getData()
      this.setAreaId()
    },
    onAreaIdChanged () {
      this.setColumnMap()
    }
  },
  watch: {
    filterSites: {
      immediate: true,
      handler (filterSites) {
        if (filterSites.length > 0) {
          this.query.siteId = filterSites[0].id
          this.getData()
          this.setAreaId()
        }
      }
    }
  },
  created () {
    this.$api.EnvFactor.getEnvFactorCategory().then(data => {
      this.envCategoryList = data
    }).catch(console.error)
  }
}
</script>

<style lang="scss" scoped>
.env-history-layout-content {
  .data-wrapper {
    /deep/ {
      > .data-wrapper-body {
        display: grid;
        grid-template-columns: minmax(200px, max-content) auto;

        > * {
          min: {
            width: 0;
            height: 0;
          }
        }
      }
    }
  }
}

.select-group-wrapper {
  display: grid;
  grid-template-rows: max-content;
  grid-row-gap: 12px;
  padding-bottom: 40px;

  > * {
    min: {
      width: 0;
      height: 0;
    }
  }
}

.env-site-select-wrapper {
  display: grid;
  grid-template-rows: 34px 1px auto;

  > * {
    min: {
      width: 0;
      height: 0;
    }
  }

  > .env-site-select-header {
    font: {
      weight: 700;
    }
    line-height: 34px;
    padding: 0 10px;
    border: 1px solid #EBEEF5 {
      bottom: 0;
    };
    background-color: #f9f9f9;
  }

  > .divider {
    background-color: #EBEEF5;
  }

  .env-site-select {
    font-size: 14px;
    height: 100%;
    margin: 0;
    padding: 5px 0;
    line-height: 1.7;
    border: 1px solid #EBEEF5 {
      top: 0;
    };
    color: #606266;
    overflow: auto;

    > li {
      line-height: 2em;
      padding: 0 10px;
      cursor: pointer;

      &:hover {
        background-color: #F5F7FA;
      }

      &.selected {
        background-color: #ecf5ff;
      }
    }
  }
}

.z-tree {
  font-size: 14px;
  color: #606266;
}
</style>



// WEBPACK FOOTER //
// src/views/07Env/02History/index.vue